/* eslint-disable no-unused-vars */
import qs from "qs";
import http from "../http";

function filternonnull(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
}

function setLanguage(payload) {
  return http("PUT", `${window.API_URL}/language`, payload);
}

function getCurrentUser() {
  return http("GET", `${window.API_URL}/myInfo`);
}

function getProfile() {
  return http("GET", `${window.API_URL}/profile`);
}

function getJobSeekers(payload) {
  return http("GET", `${window.API_URL}/job-seekers?${qs.stringify(payload)}`);
}

function getUserList(payload) {
  return http("POST", `${window.API_URL}/users`, payload);
}

function updateUserRole(payload) {
  return http("PUT", `${window.API_URL}/user/${payload.idx}/role`, payload);
}

function updateUserStatus(payload) {
  return http("PUT", `${window.API_URL}/user/${payload.idx}/status`, payload);
}

function deleteUser(payload) {
  return http("DELETE", `${window.API_URL}/user/list`, payload);
}

function inviteUser(payload) {
  return http("POST", `${window.API_URL}/user/invite`, payload);
}

function initPassword(payload) {
  return http("PUT", `${window.API_URL}/passwdreset`, payload);
}

function register(payload) {
  return http("POST", `${window.API_URL}/register`, payload);
}

function updatePassword(payload) {
  return http("PUT", `${window.API_URL}/passwd`, payload);
}

function join(payload) {
  return http("POST", `${window.API_URL}/join`, payload);
}

function findAccount(payload) {
  return http("POST", `${window.API_URL}/find-account`, payload);
}

function resetPassword(payload) {
  return http("POST", `${window.API_URL}/reset-password`, payload);
}

function certifiedMyInfo(payload) {
  return http("PUT", `${window.API_URL}/certified-myInfo`, payload);
}

function myInfoPasswordChange(payload) {
  return http("PUT", `${window.API_URL}/myInfo/password`, payload);
}

function myInfoSettingChange(payload) {
  return http("PUT", `${window.API_URL}/myInfo/setting`, payload);
}

function myInfoUserDelete(payload) {
  return http("DELETE", `${window.API_URL}/withdrawal`, payload);
}

function myInfoUpdateUser(payload) {
  return http("PUT", `${window.API_URL}/myInfo`, payload);
}

function myInfoPaymentsList(payload) {
  return http(
    "GET",
    `${window.API_URL}/payments?${qs.stringify(filternonnull(payload))}`
  );
}
function getPaymentDetailListExcel(payload) {
  return http(
    "GET",
    `${window.API_URL}/payment/${payload.id}/download`,
    {},
    { responseType: "blob" }
  );
}
export default {
  setLanguage,
  getCurrentUser,
  getJobSeekers,
  getUserList,
  updateUserRole,
  updateUserStatus,
  deleteUser,
  inviteUser,
  initPassword,
  register,
  updatePassword,
  getProfile,
  join,
  findAccount,
  resetPassword,
  certifiedMyInfo,
  myInfoPasswordChange,
  myInfoSettingChange,
  myInfoUserDelete,
  myInfoUpdateUser,
  myInfoPaymentsList,
  getPaymentDetailListExcel,
};
